(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header-hulkapps-backup"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["poker-guide"] && !Shopify.designMode) return;
  try {
    
(function(){
  "use strict";
  function wire(root){
    if(root.dataset.pkWired) return; root.dataset.pkWired="1";
    var links=[].slice.call(root.querySelectorAll('[data-pk-spy]'));
    var map={}; links.forEach(function(a){map[a.getAttribute('data-pk-spy')]=a;});
    var bar=root.querySelector('[data-pk-bar]'), prog=root.querySelector('[data-pk-progress]');
    var clickLock=0;
    function setActive(a){ links.forEach(function(l){l.classList.remove('pk-active');}); if(a)a.classList.add('pk-active'); }
    if(links.length){
      var io=new IntersectionObserver(function(es){
        if(Date.now()<clickLock) return;
        es.forEach(function(e){ if(e.isIntersecting){ setActive(map[e.target.id]); } });
      },{rootMargin:'-25% 0px -65% 0px'});
      links.forEach(function(l){var el=document.getElementById(l.getAttribute('data-pk-spy')); if(el)io.observe(el);});
      links.forEach(function(l){
        l.addEventListener('click',function(ev){
          var id=l.getAttribute('data-pk-spy'), el=document.getElementById(id);
          if(!el) return;
          ev.preventDefault();
          clickLock=Date.now()+900;
          setActive(l);
          el.scrollIntoView({behavior:'smooth',block:'start'});
          if(history.replaceState) history.replaceState(null,'','#'+id);
        });
      });
    }
    var secs=[].slice.call(root.querySelectorAll('details.pk-sec'));
    var lastMobile=null;
    function syncSecs(){
      var mobile=window.matchMedia('(max-width:989px)').matches;
      if(mobile===lastMobile) return; lastMobile=mobile;
      secs.forEach(function(d,i){ if(mobile){ if(i>0){ d.removeAttribute('open'); } else { d.setAttribute('open',''); } } else { d.setAttribute('open',''); } });
    }
    syncSecs();
    window.addEventListener('resize',syncSecs);
    function onScroll(){
      var r=root.getBoundingClientRect(), vh=window.innerHeight||1;
      var total=root.offsetHeight-vh, done=Math.min(Math.max(-r.top,0),total), pct=total>0?done/total:0;
      if(bar)bar.style.width=(pct*100)+'%';
      if(prog)prog.style.width=(pct*100)+'%';
    }
    window.addEventListener('scroll',onScroll,{passive:true}); onScroll();
  }
  function init(){[].slice.call(document.querySelectorAll('.pk-guide')).forEach(wire);}
  if(document.readyState!=='loading')init(); else document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["recently-viewed-products"] && !Shopify.designMode) return;
  try {
    
  class RecentlyViewedProducts extends HTMLElement {
    constructor() {
      super();
      this.storageKey = 'theme:recently-viewed';
      this.currentHandle = this.dataset.currentHandle || '';
      this.limit = parseInt(this.dataset.limit, 10) || 4;
    }

    connectedCallback() {
      // Record the current product first (guest or logged-in — localStorage only).
      this.recordCurrent();

      const handles = this.getHandles().filter((handle) => handle && handle !== this.currentHandle);
      if (!handles.length) return;

      // Defer slightly so it never competes with critical rendering.
      const start = () => this.render(handles.slice(0, this.limit));
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(start, { timeout: 1500 });
      } else {
        window.setTimeout(start, 300);
      }
    }

    get rootUrl() {
      return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    }

    getHandles() {
      try {
        const stored = JSON.parse(window.localStorage.getItem(this.storageKey));
        return Array.isArray(stored) ? stored : [];
      } catch (e) {
        return [];
      }
    }

    recordCurrent() {
      if (!this.currentHandle) return;
      // Dedupe, most-recent first, capped so localStorage stays small.
      let handles = this.getHandles().filter((handle) => handle !== this.currentHandle);
      handles.unshift(this.currentHandle);
      handles = handles.slice(0, 20);
      try {
        window.localStorage.setItem(this.storageKey, JSON.stringify(handles));
      } catch (e) {
        // Storage unavailable (private mode / quota) — fail silently.
      }
    }

    async render(handles) {
      const cards = await Promise.all(
        handles.map((handle) =>
          fetch(`${this.rootUrl}products/${handle}?view=card`)
            .then((response) => (response.ok ? response.text() : ''))
            .catch(() => '')
        )
      );

      const markup = cards.map((card) => (card || '').trim()).filter(Boolean).join('');
      if (!markup) return;

      const headingSize = this.dataset.headingSize || 'h2';
      const heading = this.dataset.heading
        ? `<h2 class="product-recommendations__heading ${headingSize}">${this.dataset.heading}</h2>`
        : '';

      this.innerHTML = `
        ${heading}
        <ul class="grid product-grid grid--${this.dataset.columnsDesktop}-col-desktop grid--${this.dataset.columnsMobile}-col-tablet-down" role="list">
          ${markup}
        </ul>
      `;
      this.classList.add('product-recommendations--loaded');

      const wrapper = document.getElementById(this.dataset.wrapper);
      if (wrapper) wrapper.removeAttribute('hidden');
    }
  }

  if (!customElements.get('recently-viewed-products')) {
    customElements.define('recently-viewed-products', RecentlyViewedProducts);
  }

  } catch(e) { console.error(e); }
})();
})();
